import { useState, useEffect } from "react";
import { Button, Dialog, DialogActions, DialogContent, DialogTitle } from "@mui/material";
import { api, BusDefect, BusDefectAssessmentType, BusDefectHistory, BusDefectHistoryType, BusDefectRepairStatusType, BusDefectSeverityType, IWalkaroundBusDefectHistory } from "../../../logic/api";
import { PagedDataView } from "../../../components/lists/PagedDataView/PagedDataView";
import flex from "../../../styles/flex";
import { useDate } from "../../../utility/useDate";
import WaReportDefectHistoryDownloader from "../wa_reports/WaReportDefectHistoryDownloader";
import { useTranslation } from "react-i18next";

export const WaDefectHistoryDialog = (props: {
    defect: BusDefect;
    show: boolean;
    onClose: () => void;
}) => {

    const [historyListParams, setHistoryListParams] = useState<IWalkaroundBusDefectHistory>({
        defectId: props.defect.id!
    });

    const dt = useDate();
    const { t } = useTranslation();

    useEffect(() => {
        setHistoryListParams({
            defectId: props.defect.id!
        });
    }, [props.defect]);

    const [showDownloader, setShowDownloader] = useState(false);

    const getHistoryItemSummary = (history: BusDefectHistory) => {
        switch (history.historyType) {
            case BusDefectHistoryType.defectRaised:
                return t("walkarounds.history.defectRaisedBy", { createdByFullName: history.createdByFullName });
            case BusDefectHistoryType.assessmentChanged:
                return t("walkarounds.history.assessmentUpdated", { assessment: t(`walkarounds.busAssesmentStatusTypes.${BusDefectAssessmentType[history.assessment]}`), createdByFullName: history.createdByFullName });
            case BusDefectHistoryType.repairChanged:
                return t("walkarounds.history.repairStatusUpdated", { repair: t(`walkarounds.busRepairStatusTypes.${BusDefectRepairStatusType[history.repair]}`), createdByFullName: history.createdByFullName });
            case BusDefectHistoryType.severityChanged:
                return t("walkarounds.history.severityUpdated", { severity: t(`walkarounds.busSeverityStatusTypes.${BusDefectSeverityType[history.severity]}`), createdByFullName: history.createdByFullName });
            case BusDefectHistoryType.notesAdded:
                return t("walkarounds.history.notesAdded", { createdByFullName: history.createdByFullName });
            default:
                return `Unknown type: ${history.historyType.toString()}`;
        }
    };

    return (
        <Dialog open={props.show} onClose={() => props.onClose()}>
            <DialogTitle style={{ paddingBottom: 0 }}>{t("walkarounds.defectHistoryTitle")}</DialogTitle>
            <div style={{ textAlign: "left", fontWeight: 500, color: "#AAA", paddingLeft: 25, paddingRight: 25 }}>{[props.defect.busReg, props.defect.defectCheckName, props.defect.defectArea, props.defect.defectDescription,].join(" / ")}</div>
            <DialogContent>
                <div style={{ maxWidth: 450, marginTop: 20, }}>
                    <PagedDataView<IWalkaroundBusDefectHistory, BusDefectHistory>
                        apiHook={api.hooks.walkaroundDefect.listHistory}
                        parameters={historyListParams}

                        renderItem={(item) => {
                            return <div style={{ padding: 10, fontWeight: 500 }}>
                                <div style={flex.flexRows}>
                                    <div style={flex.flexAuto}>{dt.toFormattedFullDateTimeString(item.created)}</div>
                                    <div style={{ width: 20 }}></div>
                                    <div style={flex.flexFill}>{getHistoryItemSummary(item)}{item.notes.length == 0 ? "" : ` "${item.notes}"`}</div>
                                </div>
                            </div>
                        }}
                    />
                </div>
            </DialogContent>
            <DialogActions>

                <WaReportDefectHistoryDownloader
                    defectId={props.defect.id!}
                    show={showDownloader}
                    callBack={() => {
                        setShowDownloader(false);
                    }}>
                    <Button onClick={() => {
                        setShowDownloader(true);
                    }}>Print</Button>
                </WaReportDefectHistoryDownloader>
                <Button onClick={() => props.onClose()}>{t("walkarounds.defectClose")}</Button>
            </DialogActions>
        </Dialog>
    );
};